export const UPLOAD_FILE = "UPLOAD_FILE";

// upload file
export function uploadFile(data, callback) {
  return {
    type: UPLOAD_FILE,
    payload : {data, callback},
  };
}